import { notificationDanger } from '@/utils/notification'
import { apiGetAuth, apiGetAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_PROMO_REPORT } from '@/utils/api-url'
import { exportCustomHeaderAndResponseType } from '@/utils/helper'

const state = () => {
  return {
    list_data: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_DATA (state, payload) {
    state.list_data = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload){
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListData (context, payload) {
    const newPayload = {
      ...payload,
      sort_by: undefined,
      search: undefined
    }
    try {
      const response = await apiGetAuth(API_PROMO_REPORT.LIST_PROMO_REPORT, newPayload)
      context.commit('SET_DATA', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error){
      notificationDanger(error)
    }
  },
  async exportPromoReport (_, payload) {
    try {
      const response = await apiGetAuthWithCustomHeadersResponseType(API_PROMO_REPORT.EXPORT_PROMO_REPORT, payload)

      const currentDate = new Date().toISOString().split('T')[0]
      exportCustomHeaderAndResponseType(response.data, `Export Promo Report - ${currentDate}.xlsx`)
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  }
}

const getters = {
  list_data (state) {
    return state.list_data
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
